import React from "react";

import moment from "moment";
import profile_img from "../../../assets/avatar_placeholder.svg";
import PrdoductList from "./ProductActions";
import { useNavigate } from "react-router-dom";
import { ClockIcon, EyeIcon } from "@heroicons/react/24/outline";
import { classNames } from "../../../helpers";
import { billingPeriod } from "../../../utils/constants";
import { TwButton } from "../../../components/tailwind";
import { CheckCircleIcon } from "@heroicons/react/20/solid";

export default function ConsumersProductTile({
  data,
  bookProduct,
  reloadData,
}) {
  const navigate = useNavigate();

  return (
    <li
      className={`col-span-1 p-0 group relative cursor-pointer [bg-white] hover:bg-list-hover shadow border border-bright-gray rounded-2xl bg-[#f8efe2]`}

    >
      <div className="group relative">
        {/* <img alt="" src={data.topicImage.length > 0 ? data.topicImage[0] : profile_img}
          className="aspect-square w-full rounded-t-2xl bg-gray-200 object-cover group-hover:opacity-75 lg:aspect-auto lg:h-80"
          onClick={handleClick} /> */}
        {/* <div className="size-11 shrink-0">
        </div> */}
        <div className="px-6 py-4 flex flex-col gap-3">
          <div className="flex-1 flex flex-col gap-2">
            {/* <div className="flex items-center gap-x-4 text-xs justify-between w-full overflow-x-hidden">
              <div className="flex-1">
                {data?.availableForSale && (<button
                  type="button"
                  className="relative z-10 rounded-full bg-gray-50 px-2.5 py-0.5 font-medium text-light-brown-coffee hover:bg-gray-100 border border-gray-200 line-clamp-1"
                >
                  {"Available For Sale"}
                </button>)}
              </div>
              <div className="flex-none text-sm text-gray-500 inline-flex justify-end items-center gap-1 line-clamp-1">€ {data?.price}</div>
            </div> */}
            <div className="font-bold text-gray-900 line-clamp-1">{data?.productName}</div>

            <div className="text-sm text-gray-500 line-clamp-2 inline-flex items-center gap-1">
              <CheckCircleIcon className="size-4 text-brown-coffee" />
              {data?.productFields?.allowAllClasses
                ?
                (<>
                  Valid for
                  <span className="text-brown-coffee">
                    all </span>
                  activities
                </>)
                :
                <>
                  Valid for
                  <span className="text-brown-coffee">
                    {!data?.productFields?.allowAllClasses && data?.productFields?.classList != undefined && data?.productFields?.classList.length > 0
                      // ? `${data?.productFields?.classList[0]?.className}`
                      ? `${data?.productFields?.classList.map((d) => d.className).join(", ")}`
                      : ''}
                  </span>
                  activity
                </>}
            </div>
            {data?.productType == "classpass" && (<div className="text-sm text-gray-500 line-clamp-2 inline-flex items-center gap-1">
              {data?.productType == "classpass" ? (data?.productFields?.validUntilConsumed === true ? (
                <>
                  <CheckCircleIcon className="size-4 text-brown-coffee" />
                  Valid{' '}
                  <span className="text-brown-coffee">
                    Until Consumed
                  </span>
                </>
              ) : (
                <>
                  <CheckCircleIcon className="size-4 text-brown-coffee" />
                  Valid{' '}
                  <span className="text-brown-coffee">
                    {data.productFields.validityDays} days
                  </span>{' '}
                  from purchase date
                </>
              )) : (<span className="text-brown-coffee">
                {/* {billingPeriod.find((f) => f.data.interval == data?.productFields?.billingPeriod.interval && f.data.interval_count == data?.productFields?.billingPeriod.interval_count).title} */}
              </span>)}
            </div>)}
            {data?.productType == "classpass" ? (<div className="text-sm text-gray-500 line-clamp-2 inline-flex items-center gap-1">
              <CheckCircleIcon className="size-4 text-brown-coffee" /> Just{' '}
              <span className="text-brown-coffee">
                €
                {parseFloat(
                  data.price / data.productFields.noOfAllowedSessions,
                ).toFixed(2)}
              </span>{' '}
              per lesson.
            </div>) : (<div className="text-sm text-gray-500 line-clamp-2 inline-flex items-center gap-1">
              <CheckCircleIcon className="size-4 text-brown-coffee" />
              <span className="text-brown-coffee">Unlimited</span>
              {' '}Credits
            </div>)}
            {/* {data?.productType == "subscription" && (<div className="text-sm text-gray-500 line-clamp-2 inline-flex items-center gap-1">
              View Details
            </div>)} */}
            {/* <div className="text-sm text-gray-500 line-clamp-2" dangerouslySetInnerHTML={{ __html: data?.topicContent }}></div> */}
          </div>
          <div className="flex shrink-0 justify-between items-center gap-x-0">
            <div className="flex-1 flex flex-col gap-0 text-xl font-extrabold text-gray-900">
              €{Number(data.price).toFixed(2)} <span className="text-sm font-normal text-gray-500">{data?.productType == "subscription" ? `per ${billingPeriod.find((f) => f.data.interval == data?.productFields?.billingPeriod.interval && f.data.interval_count == data?.productFields?.billingPeriod.interval_count).data.interval}` : ""}</span>
            </div>
            <div className="text-base text-gray-500 line-clamp-2" >
              <TwButton
                variant="brown-coffee"
                className="!px-3 !py-2 text-sm"
                onClick={() => {
                  bookProduct(data._id);
                }}
              >
                {data?.productType == "subscription" ? 'Subscribe' : 'Buy Now'}
              </TwButton>
            </div>
          </div>
        </div>
      </div>

    </li>
  );
}
